/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
    selector: "[bciLoadingTextSkeleton]",
    standalone: false
})
export class LoadingTextSkeletonDirective {
  @HostBinding("class.loadingTextSkeleton") @Input() bciLoadingTextSkeleton =
    true;

  constructor() {}
}
